import { useEffect, useMemo } from 'react';
import { usePurchaseMotions } from 'purchase-motions-components/hooks/usePurchaseMotions';
import { TalkToSalesButton } from 'purchase-motions-components/components/PurchaseMotions/TalkToSalesButton/TalkToSalesButton';
import { track } from '../../_core/common/eventTracking/tracker';
import { formatNumbersInString } from '../../_core/utils/formatNumbersInString';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { writeUpgradeConfigToLocalStorage } from '../../_core/utils/upgradeConfigCache';
import { getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import DefaultBanner from './DefaultBanner';
import { getTrackingDataFromUpgradeConfig } from '../../_core/utils/getTrackingDataFromUpgradeConfig';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  'data-test-id': dataTestId = 'limit-pack-banner',
  displayBannerOverride = false
}) => {
  const {
    purchaseMotions
  } = usePurchaseMotions({
    location: 'TALK_TO_SALES_BUTTON',
    apiName: upgradePoint.bestFitApiNameForPurchase
  });
  const limitInteractionTrackingData = useMemo(() => ({
    limit,
    value,
    displayThreshold,
    hasReachedLimit: value >= limit
  }), [limit, value, displayThreshold]);
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, limitInteractionTrackingData, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint, limitInteractionTrackingData]);
  if (!displayBannerOverride && displayThreshold && value < displayThreshold) {
    return null;
  }
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.content);
  const formattedBannerTitle = bannerTitle ? formatNumbersInString(bannerTitle) : undefined;
  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: /*#__PURE__*/_jsx(_Fragment, {
      children: formattedBannerTitle
    }),
    dataTestId: dataTestId,
    subtext: /*#__PURE__*/_jsx(_Fragment, {
      children: bannerSubtitle
    }),
    button: /*#__PURE__*/_jsx(TalkToSalesButton, {
      "data-test-id": "limit-pack-talk-to-sales-button",
      apiName: upgradePoint.bestFitApiNameForPurchase,
      trackingData: Object.assign({}, getTrackingDataFromUpgradeConfig(upgradePoint), {
        usageLimitBannerData: limitInteractionTrackingData
      }),
      upgradeConfig: upgradePoint,
      uiButtonProps: {
        size: 'extra-small',
        use: 'secondary'
      },
      isUpgradePoint: true,
      isAssignable: purchaseMotions[0] === 'TALK_TO_SALES',
      onClick: () => writeUpgradeConfigToLocalStorage(upgradePoint)
    })
  });
};
export default LimitPackBanner;